import { ActionType } from '../../phasrRecommendations/phasrRecommendationsGrid/types';

export interface PhasrApplyActionSchema {
  id: string,
  companyId: string,
  ruleId: number,
  createdOn?: number,
  reductionPotential?: number,
  description: string,
  targetedActivityType: string,
  rule: string | number,
  collection?: ApplyActionCollections,
  action?: ActionType,
  type?: number,
}

export enum PhasrApplyActionPanelEvents {
  APPLY_ACTION = 'apply',
  CANCEL = 'cancel',
  BEHAVIORAL_PROFILE_TYPE_CHANGED = 'behavioral-profile-type-changed',
}

export enum Collections {
  RECOMMENDATIONS = 'recommendations',
  RULES = 'rules',
}

export type ApplyActionCollections = Collections.RECOMMENDATIONS | Collections.RULES;
